/* eslint-disable prettier/prettier */
import React from "react";
import PropTypes from "prop-types";

// Components
import {
  ICON_COLOR as SVG_ICON_COLOR,
  convertToOptions,
} from "@gcloud-npm/next12.components.icon";
import FaqItem, { VARIANT } from "@/components/Faqs/components/FaqItem";
import TextInfo, {
  TEXT_INFO_COLOR,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_HEADING_LEVEL,
  TEXT_INFO_KIND,
  TEXT_INFO_SIZE,
  TEXT_INFO_SEGMENT,
  TEXT_INFO_ALIGN,
} from "@gcloud-npm/next12.components.text-info";

// Styles
import { faqsCss } from "./styles";

export const COMPONENT_NAME = "Faqs";

const Faqs = ({
  openAllQuestions,
  title,
  listadoFAQS,
  faqItemOptions,
  variant,
  Icon,
  segment,
  taggingInfo,
}) => {
  return (
    <>
      <section className="faqs container">
        <TextInfo
          className="faqs__title"
          kind={TEXT_INFO_KIND.HEADING}
          level={TEXT_INFO_HEADING_LEVEL.H2}
          align={TEXT_INFO_ALIGN.CENTER}
          fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
          size={TEXT_INFO_SIZE.TITLE3}
          text={title || ""}
          color={TEXT_INFO_COLOR.GREY_6}
        />
        <ul>
          {listadoFAQS &&
            Array.isArray(listadoFAQS) &&
            listadoFAQS.length > 0 &&
            listadoFAQS.map((eachQuestion, index) => (
              <FaqItem
                key={`faq-${eachQuestion.title}`}
                isOpen={openAllQuestions}
                faqTitle={eachQuestion.title}
                faqContent={eachQuestion.content}
                taggingInfo={{
                  ...taggingInfo,
                  ComponentName: COMPONENT_NAME,
                }}
                options={faqItemOptions}
                variant={variant}
                Icon={Icon}
                segment={segment}
                index={index}
              />
            ))}
        </ul>
      </section>
      <style jsx>{faqsCss}</style>
    </>
  );
};

Faqs.propTypes = {
  /**
   * {
   * "info": "Booleano que nos permite abrir todas las preguntas por defecto",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  openAllQuestions: PropTypes.bool,
  /**
   * {
   * "info": "Titulo que aparece para la lista de las preguntas frecuentes/faqs",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  title: PropTypes.string.isRequired,
  /**
   * {
   * "info": "Listado de preguntas frecuentes/faqs",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  listadoFAQS: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  /**
   * {
   * "info": "Opciones para cambiar los colores de cada pregunta frecuente/faq",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  faqItemOptions: PropTypes.shape({
    /**
     * {
     * "info": "Cuando la pregunta frecuente/faq está sin abrir",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    default: PropTypes.shape({
      color: PropTypes.shape({
        title: PropTypes.oneOf(Object.values(TEXT_INFO_COLOR)),
        icon: PropTypes.oneOf(Object.values(SVG_ICON_COLOR)),
      }),
    }),
    /**
     * {
     * "info": "Cuando la pregunta frecuente/faq está abierta",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    activated: PropTypes.shape({
      color: PropTypes.shape({
        title: PropTypes.oneOf(Object.values(TEXT_INFO_COLOR)),
        icon: PropTypes.oneOf(Object.values(SVG_ICON_COLOR)),
      }),
    }),
    /**
     * {
     * "info": "El contenido de la faq"
     * }
     */
    content: PropTypes.shape({
      color: PropTypes.oneOf(Object.values(TEXT_INFO_COLOR)),
    }),
  }),
  /**
   * {
   * "info": "Dependiendo del tipo de "variant" se cambian los estilos de cada pregunta frecuente/faq. Es un modificador",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  variant: PropTypes.oneOf(Object.values(VARIANT)),
  Icon: PropTypes.func.isRequired,
  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: PropTypes.oneOf(convertToOptions(TEXT_INFO_SEGMENT)),
};

Faqs.defaultProps = {
  openAllQuestions: false,
  segment: TEXT_INFO_SEGMENT.GP,
  faqItemOptions: {
    default: {
      color: {
        title: TEXT_INFO_COLOR.GREY_5,
        icon: SVG_ICON_COLOR.GREY_7,
      },
    },
    activated: {
      color: {
        title: TEXT_INFO_COLOR.BLUE,
        icon: SVG_ICON_COLOR.BLUE,
      },
    },
  },
  variant: VARIANT.DEFAULT,
};

export default Faqs;
